var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconTaskListPen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 6.359V22.51a.75.75 0 0 1-.75.75h-12a.75.75 0 0 1-.75-.75V6.76m16.5 13.5 1.5 3 1.5-3v-9.75a1.5 1.5 0 0 0-1.5-1.5h0a1.5 1.5 0 0 0-1.5 1.5Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75.76h0a3 3 0 0 1 3 3h0a3 3 0 0 1-3 3h12a3 3 0 0 0 3-3h0a3 3 0 0 0-3-3h-12Zm0 0h0a3 3 0 0 0-3 3v12M9 11.26l1.5 1.5 2.25-2.25m-3.75 6 1.5 1.5 2.25-2.25",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconTaskListPen);
export default __webpack_public_path__ + "static/media/streamline-icon-task-list-pen.3b0d709c.svg";
export { ForwardRef as ReactComponent };